import React from "react"
import { Helmet } from "react-helmet-async"

export interface MetaProps {
    title: string
    globalTitle?: string
    description: string
    image?: string
    video?: string
}

export const Meta = ({
    title,
    globalTitle = "Super.AI",
    description,
    image,
    video
}: MetaProps) => {
    const fullTitle = `${title} | ${globalTitle}`
    const url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname
    return (
        <Helmet>
            {/* <!-- COMMON TAGS --> */}
            <title>{fullTitle}</title>
            {/* <!-- Search Engine --> */}
            <meta name="description" content={description} />
            {image && <meta name="image" content={image} />}
            {/* <!-- Schema.org for Google --> */}
            <meta itemProp="name" content={fullTitle} />
            <meta itemProp="description" content={description} />
            {image && <meta itemProp="image" content={image} />}
            {/* <!-- Twitter --> */}
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            {image && <meta name="twitter:image:src" content={image} />}
            {/* <!-- Open Graph general (Facebook, Pinterest & Google+) --> */}
            <meta name="og:title" content={fullTitle} />
            <meta name="og:description" content={description} />
            {image && <meta name="og:image" content={image} />}
            <meta name="og:url" content={url} />
            <meta name="og:site_name" content="super.AI" />
            <meta name="og:locale" content="en_US" />
            {video && <meta name="og:video" content={video} />}
            <meta name="og:type" content="website" />
        </Helmet>
    )
}
